import { Link,useParams } from "react-router-dom";
import { Button } from 'semantic-ui-react';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect } from "react";
import { HTTPURL } from "../constants/matcher";

export default function VerifyAccount() {
    const params = useParams();

    const componentDidMount = () => {
        // GET request using fetch with error handling
        // fetch('http://localhost:8090/'+params.code)
        fetch(HTTPURL+params.code)
            .then(async response => {
                const data = await response.json();
    
                // check for error response
                if (!response.ok) {
                    // get error message from body or default to response statusText
                    const error = (data && data.message) || response.statusText;
                    return Promise.reject(error);
                }
                console.log('gjhsdfjds', data);
                if(data.status===true){
                    toast.success(data.message)
                }else{
                    toast.error(data.message)
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
    }

    useEffect(() => {
        componentDidMount();
    }, []);

    return (
        <section className="h-100 bg-dark">
            {/* <ToastContainer /> */}
            <div className="container py-5 h-100">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="col">
                        <div className="card card-registration my-4">
                            <div className="row g-0">
                                <div className="col-xl-6 d-none d-xl-block">
                                    <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/img4.webp"
                                        alt="" className="img-fluid"
                                        // style={{border-top-left-radius: '.25rem', border-bottom-left-radius: '.25rem'}} 
                                    />
                                </div>
                                <div className="col-xl-6 d-flex justify-content-center align-items-center">
                                    {/* <h2>Comming soon...</h2> */}
                                    <div className="d-flex justify-content-center pt-3">
                                        <Link to="/login" className="nav-link">
                                            <Button type="button" className="btn btn-light btn-lg">Login</Button>
                                        </Link>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};

// export default VerifyAccount;